<script>
export default {
  computed: {
    currentConference() {
      return this.$store.state.conference.currentConference
    },
  },
  created() {
    this.$store.dispatch('conference/getCurrentConference').then(() => {})
  }
}
</script>
